import '../scss/vxol.scss';

import Map from 'ol/Map.js';
import View from 'ol/View.js';
//import LayerGroup from 'ol/layer/Group';
//import TileLayer from 'ol/layer/Tile.js';

//import OSM from 'ol/source/OSM.js';
//import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';

import LayerSwitcher from 'ol-layerswitcher';

//import { getLayerByNameWMTS, getGigapanLayerGroup } from './vxLayerLibrary';
import vxOverlay from './vxOverlay'; 
import vxOlGigapan from './vxOlGigapan';
import vxVdaMap from './vxVdaMap';

class vxOlMap {
    static overlay;
    static overlayContent;
    static overlayContainer;
    static overlayCloser;
    static map;
    static wmtsCapabilities;
}

export function initGis(initparam) {
    const parser = new WMTSCapabilities();
    let map;

    fetch('/geoserver/gwc/service/wmts?service=WMTS&acceptVersions=1.0.0&request=GetCapabilities')
        .then(function (response) {
            return response.text();
        })
        .then(function (text) {
            vxOlMap.wmtsCapabilities = parser.read(text);;

            // layer groups
            const baseMaps = vxVdaMap.getBaseLayerGroup(vxOlMap);

            const baseTopo = vxVdaMap.getTopoLayerGroup(vxOlMap);

            const baseGeo = vxVdaMap.getGeologyLayerGroup(vxOlMap);

            const ctrMaps = vxVdaMap.getCtrLayerGroup(vxOlMap);

            vxOlMap.gigapanMaps = vxVdaMap.getGigapanLayerGroup();

            //overlay
            const overlay = vxOverlay.createOverlay(vxOlMap);

            //layer selector
            const layerSwitcher = new LayerSwitcher({
                reverse: true,
                groupSelectStyle: 'group'
            });

            // create map

            vxOlMap.map = new Map({
                target: 'map',
                overlays: [overlay],
                layers: [baseMaps, ctrMaps, baseTopo, baseGeo, vxOlMap.gigapanMaps],
                view: new View({ enableRotation: false }),
            });

            vxOlMap.map.getView().fit(initparam.extent, vxOlMap.map.getSize());

            vxOlMap.map.addControl(layerSwitcher);

            /**
            * Add a click handler to the map to render the popup.
            */

            vxOlMap.map.on('singleclick', function (evt) { return vxOverlay.onGenericClick(evt, vxVdaMap.getResultDiv); });

            /**
            * Zoom to point of interest.
            */
            if (initparam.center != 'undefined' && initparam.zoom != 'undefined') {
                vxOlMap.map.getView().animate({ center: initparam.center, duration: 1000 }, { zoom: initparam.zoom, duration: 1000 },);
            }

        });
};

export function initGigapan(initparam) {

    const overlay = vxOverlay.createOverlay(vxOlMap);

    vxOlMap.map = new Map({
        layers: vxOlGigapan.getGigapanLayers(initparam, vxOlMap),
        overlays: [overlay],
        target: 'map',
    });

    vxOlGigapan.refreshMap(document.getElementById('iiif-notification')).then(
        function (loadok) {
            if (loadok && initparam.center != 'undefined' && initparam.zoom!='undefined') {
                vxOlMap.map.getView().animate({ center: initparam.center, duration: 1000 }, { zoom: initparam.zoom, duration: 1000 },);
            }
        }
    );

    const layerSwitcher = new LayerSwitcher({
        reverse: true,
        groupSelectStyle: 'group'
    });
    vxOlMap.map.addControl(layerSwitcher);

    vxOlMap.map.on('singleclick', function (evt) { return vxOverlay.onGenericClick(evt, vxOlGigapan.getSelectionOverlay); });
}

